module.exports = __webpack_public_path__ + "static/media/icon-re.7abbc08d.svg";